import { handleActions } from 'redux-actions';

import {
  receivedTimeline,
  receivedModel,
  receivedGraphState,
  receivedEquipment,
  receivedFlags,
  receivedConfig,
  receivedEquipmentConfig,
  setCmrsStatus,
  receivedSessionId,
  gotApiError,
} from './actions';

const defaultState = {
  observations: [],
  causes: [],
  consequences: [],
  models: {},
  flags: {},
  config: {},
  equipment: {
    config: {},
    events: [],
  },
  cmrsStatus: {},
  sessionId: null,
  apiError: null,
};

export default handleActions(
  {
    [receivedTimeline]: (state, action) => {
      return {
        ...state,
        observations: action.payload,
      };
    },
    [gotApiError]: (state, action) => {
      return {
        ...state,
        apiError: action.payload,
      };
    },
    [receivedSessionId]: (state, action) => {
      return {
        ...state,
        sessionId: action.payload,
      };
    },
    [receivedGraphState]: (state, { payload }) => {
      const { causes = [], consequences = [] } = payload;
      return {
        ...state,
        causes,
        consequences,
      };
    },
    [receivedModel]: (state, action) => {
      return {
        ...state,
        models: action.payload,
      };
    },
    [receivedFlags]: (state, action) => ({
      ...state,
      flags: { ...action.payload },
    }),
    [receivedConfig]: (state, action) => ({
      ...state,
      config: { ...action.payload },
    }),
    [receivedEquipment]: (state, action) => {
      const events = action.payload;
      return {
        ...state,
        equipment: {
          ...state.equipment,
          events,
        },
      };
    },
    [receivedEquipmentConfig]: (state, action) => {
      const config = action.payload;
      return {
        ...state,
        equipment: {
          ...state.equipment,
          config,
        },
      };
    },
    [setCmrsStatus]: (state, action) => {
      const { reasoning } = action.payload;
      return {
        ...state,
        cmrsStatus: reasoning,
      };
    },
  },

  defaultState
);
